import { createStructuredSelector } from 'reselect'
import { connect } from 'react-redux'
import { getScreenWidth, getScreenIsReady } from 'selectors/screen'
import { getAlgoliaDataHitsResults } from '../selectors/algolia'
import { getArtistName, getIsUsersCollectionPage } from '../selectors/app'
const mapStateToProps = createStructuredSelector({
  collectionsList: getAlgoliaDataHitsResults,
  isReady: getScreenIsReady,
  screenWidth: getScreenWidth,
  artistName: getArtistName,
  isUsersCollectionPage: getIsUsersCollectionPage,
})

const mapDispatchToProps = (dispatch) => ({})

export type ConnectorProps = {
  collectionsList: Record<string, any>
  isReady: boolean
  screenWidth: number
  artistName: string
  isUsersCollectionPage: boolean
}
export default connect(mapStateToProps, mapDispatchToProps)
